import { Link } from 'react-router-dom';

import appStoreBadge from '../assets/badges/app_store_badge.svg';
import googlePlayBadge from '../assets/badges/en_get.svg';
import instagramIcon from '../assets/icons/instagram_icon.svg';
import threadsIcon from '../assets/icons/threads_icon.svg';
import wolishoW from '../assets/logos/wolisho_w.svg';

const navLinks = [
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
  { label: 'Terms of use', to: '/terms' },
  { label: 'Privacy Policy', to: '/privacy' },
];

const socialLinks = [
  { icon: instagramIcon, label: 'Instagram', href: 'https://www.instagram.com/wolishodotcom' },
  { icon: threadsIcon, label: 'Threads', href: 'https://www.threads.com/@wolishodotcom' },
];

function Logo() {
  return <img src={wolishoW} alt="Wolisho" className="h-10 w-auto" />;
}

function StoreBadges() {
  return (
    <>
      <a
        href="https://apps.apple.com"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Download on the App Store"
      >
        <img src={appStoreBadge} alt="Download on the App Store" className="h-10" />
      </a>
      <a
        href="https://play.google.com"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Get it on Google Play"
      >
        <img src={googlePlayBadge} alt="Get it on Google Play" className="h-10" />
      </a>
    </>
  );
}

function NavLinks() {
  return (
    <>
      {navLinks.map((link) => (
        <Link
          key={link.to}
          to={link.to}
          className="text-sm font-bold text-white hover:underline"
        >
          {link.label}
        </Link>
      ))}
    </>
  );
}

function SocialIcons() {
  return (
    <>
      {socialLinks.map((link) => (
        <a
          key={link.label}
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={link.label}
          className="text-white hover:opacity-80"
        >
          <img src={link.icon} alt="" className="h-6 w-6" />
        </a>
      ))}
    </>
  );
}

export function Footer() {
  return (
    <footer className="bg-wolisho-red px-4 py-6 md:px-8 md:py-4">
      {/* Mobile Layout */}
      <div className="flex flex-col items-center gap-4 md:hidden">
        <Logo />
        <div className="flex items-center gap-3">
          <StoreBadges />
        </div>
        <nav className="flex flex-wrap justify-center gap-x-4 gap-y-2">
          <NavLinks />
        </nav>
        <div className="flex items-center gap-4">
          <SocialIcons />
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="mx-auto hidden max-w-7xl items-center justify-between md:flex">
        <div className="flex items-center gap-4">
          <Logo />
          <StoreBadges />
        </div>
        <nav className="flex items-center gap-6">
          <NavLinks />
        </nav>
        <div className="flex items-center gap-4">
          <SocialIcons />
        </div>
      </div>
    </footer>
  );
}
